/**
 * MEDIA-VIEWER.JS
 */

import lightGallery from "lightgallery";
import lgVideo from "lightgallery/plugins/video";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-video.css";

export default class MediaViewer {

	static init() {
		return new MediaViewer();
	}

	constructor() {
		const lightGalleries = document.querySelectorAll(".media-viewer");
		const instances = [];
		const config = {
			selector: ".media-viewer-item",
			licenseKey: atob("SEo3S04tU1RHUjctUjhLR0YtQ1UzVzM="),
			plugins: [lgVideo],
			download: false,
			mobileSettings: {
				showCloseIcon: true,
				download: false,
			},
		};
		
		if (lightGalleries.length === 0) return;

		lightGalleries.forEach((gallery) => {
			let instance = lightGallery(gallery, config);
			instances.push(instance);

			// adds a superflous history entry. This enables pressing the 'back' button 
			// in the browser and closing the gallery without jumping back to previous page
			gallery.addEventListener('lgAfterOpen', (event) => {
				history.pushState({ lg: "close" }, null, window.location.href); 	
			});

			// If the proper close button is used in the lightgallery, 
			// the superflous history entry has to be removed
			gallery.addEventListener('lgBeforeClose', (event) => {
				if (history.state?.lg === "close") history.back();
			});
		});

		// close gallery when user clicks 'back'
		window.onpopstate = function(event) { 
			instances.forEach((instance) => {
				instance.closeGallery();
			});
		}
	}
}
